import React from 'react';
import { Trophy, MapPin, Calendar } from 'lucide-react';
import { usePortfolio } from '../context/PortfolioContext';

const Awards = () => {
  const { portfolioData, loading } = usePortfolio();
  
  if (loading || !portfolioData) {
    return null;
  }
  
  const { awards } = portfolioData;

  return (
    <section id="awards" data-story-section className="py-32 bg-gradient-to-b from-zinc-950 via-zinc-900 to-zinc-950 relative overflow-hidden">
      {/* Soft glow background */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(255,77,109,0.07),transparent_40%),radial-gradient(circle_at_80%_60%,rgba(110,231,255,0.05),transparent_35%)]"></div>
      
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-20 space-y-4">
          <h2 className="text-sm font-semibold text-orange-500 uppercase tracking-wider">Recognition</h2>
          <h3 className="text-5xl md:text-6xl font-bold text-white">
            Awards & <span className="gradient-text">Achievements</span>
          </h3>
        </div>

        <div className="max-w-4xl mx-auto">
          {awards.map((award, index) => (
            <div key={index} className="glass p-12 rounded-3xl border border-orange-500/20 hover:border-orange-500/40 transition-all duration-300 relative overflow-hidden group">
              {/* Decorative glow effect */}
              <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-br from-orange-500/10 to-amber-500/10 rounded-full blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative z-10">
                <div className="flex items-start gap-8 mb-8">
                  <div className="p-6 bg-gradient-to-br from-amber-400 via-orange-500 to-orange-600 rounded-3xl shadow-2xl shadow-orange-500/30 group-hover:scale-110 transition-transform duration-300">
                    <Trophy size={48} className="text-white" />
                  </div>
                  <div className="flex-1">
                    <h4 className="text-3xl font-bold text-white mb-3 group-hover:text-orange-500 transition-colors">{award.title}</h4>
                    <p className="text-xl font-semibold text-orange-500">{award.subtitle}</p>
                  </div>
                </div>

                <div className="flex flex-wrap gap-6 mb-8">
                  <div className="flex items-center gap-2 text-gray-400">
                    <div className="p-2 bg-orange-500/10 rounded-lg">
                      <Calendar size={20} className="text-orange-500" />
                    </div>
                    <span>{new Date(award.date).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-400">
                    <div className="p-2 bg-orange-500/10 rounded-lg">
                      <MapPin size={20} className="text-orange-500" />
                    </div>
                    <span>{award.location}</span>
                  </div>
                </div>

                <p className="text-lg text-gray-300 leading-relaxed">
                  {award.summary}
                </p>
              </div>

              {/* Decorative corner stars */}
              <svg className="absolute bottom-6 right-6 w-20 h-20 text-orange-500/20 group-hover:text-orange-500/40 transition-colors" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
              </svg>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Awards;
